const Home = () => {
  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-4 py-8">
      {/* Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-50">
        <div className="absolute top-20 right-20 w-72 h-72 bg-blue-400/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 left-20 w-72 h-72 bg-indigo-400/20 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-3xl w-full text-center relative z-10">
        {/* Logo with enhanced styling */}
        <div className="flex justify-center mb-8 animate-fade-in">
          <div className="bg-white/80 backdrop-blur-sm rounded-3xl p-8 shadow-xl ring-1 ring-gray-200/50 transform hover:scale-105 transition-transform duration-300">
            <img
              src="https://www.coragroup.com.au/wp-content/uploads/2024/12/cora-mark-logo.png"
              alt="Cora Group company logo"
              className="w-18 h-auto drop-shadow-lg"
            />
          </div>
        </div>

        {/* Main content card */}
        <div className="bg-white/70 backdrop-blur-xl rounded-2xl shadow-2xl p-8 sm:p-12 ring-1 ring-gray-200/50 animate-fade-in">
          <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6 bg-gradient-to-r from-[#144677] to-[#1a5691] bg-clip-text text-transparent">
            Welcome to the Cora Pricing Tool
          </h1>

          <div className="space-y-4 text-left">
            <p className="text-lg text-gray-700 leading-relaxed">
              This web application is developed by{" "}
              <strong className="text-[#144677] font-semibold">
                Cora Group
              </strong>
              . It serves as an internal pricing model tool for the
              organization, offering an intuitive interface to calculate and
              manage various pricing strategies.
            </p>

            <p className="text-base text-gray-600 leading-relaxed">
              Use this tool to streamline your pricing process and make informed
              decisions backed by data.
            </p>
          </div>

          {/* Feature highlights */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-8">
            <div className="bg-gradient-to-br from-blue-50 to-blue-100/50 rounded-xl p-4 hover:shadow-md transition-shadow duration-200">
              <div className="text-[#144677] text-3xl mb-2">📊</div>
              <h3 className="font-semibold text-gray-900 mb-1">Data-Driven</h3>
              <p className="text-sm text-gray-600">
                Make informed pricing decisions
              </p>
            </div>

            <div className="bg-gradient-to-br from-indigo-50 to-indigo-100/50 rounded-xl p-4 hover:shadow-md transition-shadow duration-200">
              <div className="text-[#144677] text-3xl mb-2">⚡</div>
              <h3 className="font-semibold text-gray-900 mb-1">Streamlined</h3>
              <p className="text-sm text-gray-600">
                Efficient pricing workflows
              </p>
            </div>

            <div className="bg-gradient-to-br from-purple-50 to-purple-100/50 rounded-xl p-4 hover:shadow-md transition-shadow duration-200">
              <div className="text-[#144677] text-3xl mb-2">🎯</div>
              <h3 className="font-semibold text-gray-900 mb-1">Accurate</h3>
              <p className="text-sm text-gray-600">Precise calculations</p>
            </div>
          </div>
        </div>

        {/* Footer text */}
        <p className="mt-6 text-sm text-gray-500">
          © 2025 Cora Group. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default Home;
